export default __webpack_public_path__ + "static/media/doc-small-blue.f55deaf8.svg";